<!-- <vs-success-msg *ngIf="showSuccess"></vs-success-msg> -->
<div *ngIf="userTypes$ | async as userTypes" class="row my-profile custom-zero-margin">
  <div class="col-md-12 tabcontent-display-line">
    <div class="row custom-bottom-border">
      <div class="col-md-12">
        <h5 class="tabcontent-display-line-section-heading">
          {{ "myProfile.custmrAccntHeader" | cxTranslate }}
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="defaultOtherPrefLabel-title">{{ "myProfile.defaultOtherPrefLabel" | cxTranslate }}</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="myprofile">
          <div class="row">
            <div class="col-md-12">
              <label class="form-all-label first-label">{{ "myProfile.cstmrAccntLabel" | cxTranslate }}</label>

              <input
              type="text"
              name="custaccount"
              formControlName="custaccount"
              autocomplete="off" 
              class="custom-defaulted-text-field"
              
            />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="form-all-label">{{ "myProfile.bakerHughesLabel" | cxTranslate }}</label>

              <input
              type="text"
              formControlName="bhbusiness"
              autocomplete="off" 
              class="custom-defaulted-text-field"
              
            />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="form-all-label">{{ "myProfile.shipToLabel" | cxTranslate }}</label>
              
              <ng-select
              [searchable]="false"
          [clearable]="false"
                class="profile-all-select custom-shipaddress-width"
                type="text"
                formControlName="shipaddress"
                >
                <ng-option *ngFor="let shipadd of addresses" [value]='shipadd.id'>
                  {{shipadd.companyName}}, {{shipadd.formattedAddress}}</ng-option>
              </ng-select>
              
            </div>
          </div>
          <div class="row custom-last-child-margin">
            <div class="col-md-12">
              <label class="form-all-label">{{ "myProfile.decimalFormateLabel" | cxTranslate }}</label>
              <ng-select
              [searchable]="false"
          [clearable]="false" 
                class="profile-all-select custom-decimal-width"
                type="text"
                formControlName="decimalformat"
              >
                <ng-option *ngFor="let decimal of decimalvalue" [value]='decimal.value'>
                  {{ decimal.value }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="row custom-border-top">
            <div class="col-md-3">
              <button
                type="submit" (click)="clearCustomerDetail()"
                class="vs-tertiary-btn custom-profile-tertiary-btn"
              >
              {{ "myProfile.cancelBtn" | cxTranslate }}
              </button>
            </div>
            <div class="col-md-3">
              <button
                type="button"
                (click)="postCustDataChange()"
                class="vs-primary-btn custom-profile-primary-btn"
              >
              {{ "myProfile.saveBtn" | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
